import { render } from "./bikes.vue?vue&type=template&id=82ac2844&scoped=true"
import script from "./bikes.vue?vue&type=script&lang=js"
export * from "./bikes.vue?vue&type=script&lang=js"

import "./bikes.vue?vue&type=style&index=0&id=82ac2844&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ac2844"]])

export default __exports__